import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../../action/webViewContentAction.js';
import './ModalTip.css';

class ModalPaySup extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
  }
  componentWillUnmount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","")
  }
  render(){
    return (
      <div>
    
      <div  className='containerModal_old' >
          <div className='modalView_old'>
            <div className='titleText_old'style = {{marginTop: this.props.titleBC ? 6 : 20}}>{this.props.title}
            </div>
            <div className='contentText_old' >
              <span>您即将投资的<span style={{fontWeight: "bold"}}>{this.props.fundName}</span>包含关联方（华夏基金）管理的产品，具体为<span style={{fontWeight: "bold"}}>{this.props.data}</span> ，请您知悉。当出现利益冲突时，华夏财富不会为自身及其关联方的利益损害投资者利益，不会为投资顾问人员及其利益相关者的利益损害您的利益，不会为特定客户利益损害其他客户利益，不会直接或间接参与内幕交易、操纵证券交易价格或通过投资组合进行非法利益输送。</span>
            </div>
            <div className='contentTwoText_old' >{this.props.contentBC}</div>
            <div className='footView_old'>
              <p  onClick={()=>{this.props.onOK()}}>{this.props.rightButtonTitle}</p>
            </div>
          </div>
        </div>:null
    
    </div>
        
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    riskModalData: state.riskModalData,
    payLoading:state.payLoading
  }
}
export default connect(mapStateToProps)(ModalPaySup);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPaySup.js